import { useState } from "react";

import { useUserInfo } from "hocs/UserInfoContext";
import Button from "components/Button/Button";
import Modal from "components/Modal/Modal";

const TermsAndConditions = () => {
  const [isOpen, setIsOpen] = useState(
    !Boolean(localStorage.getItem("isUserAgreedToTermsAndConditions"))
  );
  const [isAgree, setIsAgree] = useState(false);

  const { currentUser } = useUserInfo();

  // Don't render until user data is available
  if (!currentUser) return null;
  
  const handleContinue = () => {
    localStorage.setItem("isUserAgreedToTermsAndConditions", "true");
    
    setIsOpen(false);
  }
  
  return (
    <Modal size="sm" isOpen={isOpen}>
      <div data-testid="terms-conditions-popup">
        <div className="bg-card pt-12 pb-8 px-8 w-full rounded-lg">
          <div className="flex items-center justify-center gap-3 mb-10">
            <img
              src="/image/logo.svg"
              alt=""
              draggable="false"
              className="w-10 h-10 brightness-0 dark:invert"
            />
            <h3
              className="text-base font-semibold leading-tight text-foreground tracking-tight"
              id="modal-title"
            >
              Central
              <br />
              Valuations
            </h3>
          </div>
          <p className="text-sm text-foreground leading-relaxed mb-6">
            Welcome{currentUser?.firstName ? ` ${currentUser.firstName}` : ''}.
            Please review and agree to our terms & conditions and privacy policy before proceeding.
          </p>
          <div className="flex items-start gap-3 mb-8">
            <button
              type="button"
              role="switch"
              aria-checked={isAgree}
              onClick={() => setIsAgree(prev => !prev)}
              data-testid="terms-modal-checkbox"
              className={`relative mt-0.5 inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ${
                isAgree ? 'bg-success' : 'bg-border'
              }`}
              style={{ transitionDuration: 'var(--cv-transition-normal)' }}
            >
              <span
                aria-hidden="true"
                className={`pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow-lg ring-0 transition-transform ${
                  isAgree ? 'translate-x-5' : 'translate-x-0'
                }`}
                style={{ transitionDuration: 'var(--cv-transition-normal)' }}
              />
            </button>
            <p className="text-sm text-foreground">
              I agree to the{' '}
              <a
                className="text-accent-blue hover:underline"
                href="https://centralvaluations.ie/terms"
                target="_blank"
                rel="noopener noreferrer"
              >
                terms & conditions
              </a>
              {' '}and{' '}
              <a
                className="text-accent-blue hover:underline"
                href="https://centralvaluations.ie/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                privacy policy
              </a>
            </p>
          </div>
          <div data-testid="terms-bubbon-wrapper">
            <Button
              variant="primary"
              size="lg"
              disabled={!isAgree}
              isFullWidth
              isTextCenter
              onClick={handleContinue}
            >
              Continue
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default TermsAndConditions;